module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5bYUd"))).then(() => parcelRequire('f4eak'));